module.exports = __webpack_public_path__ + "static/media/JPG.5173f4a1.svg";